import { useWidget, MINIMIZED_STATE } from "../providers/WidgetProvider";
import {ChevronLeft} from "lucide-react"

export default function TabButton() {
  const { setWidgetState, widgetState } = useWidget();

  const handleClick = () => {
    setWidgetState(MINIMIZED_STATE);
  };

  return (
    <button
      onClick={handleClick}
      className={`fixed right-0 bottom-25 z-50 bg-black/40 rounded-l-3xl w-[36px] h-[64px] flex items-center justify-center hover:bg-black/30 transition-all duration-300 cursor-pointer backdrop-blur-xl shadow-inset-white-20 ${
        widgetState === MINIMIZED_STATE ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
      aria-label="Open widget"
    >
      <ChevronLeft size={24} color="white" />
    </button>
  );
}
